///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthCanRunDesignCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthCanRunDesignCommand';
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (this.commandResolve) {
            if (!activityDto.successful) {
                this.historyService.notificationService.showError(activityDto?.error?.message);
            }

            this.commandResolve(activityDto.successful);
        }
    }

    protected doCommand(): void {
        const abortDesignActivity = this.createActivityDTO(false);
        this.sendActivity(abortDesignActivity);
    }
}
